import { render, staticRenderFns } from "./jala-region-select-ajax.vue?vue&type=template&id=58ce2b8b&scoped=true&"
import script from "./jala-region-select-ajax.vue?vue&type=script&lang=js&"
export * from "./jala-region-select-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce2b8b",
  null
  
)

export default component.exports